import type { IconProps } from '@/types/general'

export const Dropdown = (props: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="25"
		height="26"
		viewBox="0 0 25 26"
		fill="currentColor"
		className={props.className}
	>
		<path
			d="M7.89265 10.9194C7.77266 10.9194 7.65541 10.9528 7.55601 11.0152C7.45661 11.0776 7.37961 11.1662 7.33491 11.2696C7.29022 11.373 7.27988 11.4865 7.30523 11.5954C7.33058 11.7043 7.39045 11.8037 7.47715 11.8807L12.0845 15.9729C12.1963 16.0723 12.3452 16.1277 12.5 16.1277C12.6548 16.1277 12.8036 16.0723 12.9155 15.9729L17.5229 11.8807C17.6095 11.8037 17.6694 11.7043 17.6948 11.5954C17.7201 11.4865 17.7098 11.373 17.6651 11.2696C17.6204 11.1662 17.5434 11.0776 17.444 11.0152C17.3446 10.9528 17.2273 10.9194 17.1073 10.9194H7.89265Z"
			fill="currentColor"
			fillOpacity="0.4"
		/>
	</svg>
)
